/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from "@cian/http-api/shared/http";
import {
  TGetPaymentsStatusModel,
  IGetPaymentsStatusRequest,
  IMappers,
  IGetPaymentsStatusResponse,
  IGetPaymentsStatusResponseError,
  TGetPaymentsStatusResponse
} from "./types";

const defaultConfig: TGetPaymentsStatusModel = {
  apiType: "public",
  assertStatusCodes: [200, 400],
  method: "GET",
  microserviceName: "billing-payments",
  pathApi: "/v1/get-payments-status/",
  hostType: "api"
} as TGetPaymentsStatusModel;

function createGetPaymentsStatusModel(
  parameters: IGetPaymentsStatusRequest
): TGetPaymentsStatusModel {
  return {
    ...defaultConfig,
    parameters
  };
}

export interface IGetPaymentsStatusOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IGetPaymentsStatusRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchGetPaymentsStatus<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers
}: IGetPaymentsStatusOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TGetPaymentsStatusResponse
> {
  const { response, statusCode } = await httpApi.fetch(
    createGetPaymentsStatusModel(parameters),
    config
  );

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetPaymentsStatusResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IGetPaymentsStatusResponseError);
    }
  }

  return { response, statusCode } as TGetPaymentsStatusResponse;
}

export { defaultConfig, createGetPaymentsStatusModel, fetchGetPaymentsStatus };
